import { getApiInstance } from '../helpers';
import { CountriesResI } from '../models/Countries';

const loadCountries = () => {
  return getApiInstance()
    .get('/country/list')
    .then((res) => {
      console.info('/country/list', res);
      return res.data as CountriesResI;
    });
};

export const countriesServices = {
  loadCountries,
};
